module.exports = __webpack_public_path__ + "static/media/bg-home-succession--pc.b56e1540.jpg";